// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2VWvA","alertIcon":"ConfirmModal_alertIcon__x7ELV"};